import styled from 'styled-components';

export const Wrapper = styled.div`
  &.small {
    > div {
      padding: 5px;
    }
  }

  &.noClick {
    cursor: default;
  }
`;

export const Image = styled.div`
  filter: brightness(1.2) contrast(1.2);

  &.containImage {
    background-size: contain;
  }

  &.small {
    min-height: 110px;
  }
`;
